import { __APP_NAME__ } from "config/static";

export default function Footer() {
  return (
    <footer className="bg-slate-100 dark:bg-mainDark text-gray-500 text-center py-6 px-4">
      <p dir="ltr">
        &copy; 2025 .العالمية للابتوب
        <br />
        .جميع الحقوق محفوظة
      </p>
    </footer>
  );
}
